module.exports = __webpack_public_path__ + "static/media/stableicon.5e8c152b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/stableicon.png
 ** module id = 2714
 ** module chunks = 0
 **/